import React from 'react';
import { useIntl } from 'react-intl';
import { CircularProgress, IconButton, Tooltip, Typography } from '@mui/material';

import { Icon, SquareChip, useSettings, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

interface AtokaInfoSectionProps {
	atokaId: string;
	lastImportDate: string;
	linkAtokaCompany: VoidFunction;
	isLoading?: boolean;
}

export default function AtokaInfoSection(props: AtokaInfoSectionProps) {
	const { t } = useSettings();
	const intl = useIntl();

	return (
		<DetailsSectionWrapper
			avatar={
				props.isLoading ? <CircularProgress size={24} disableShrink /> : <Icon pack="wise" icon="logo-atoka" />
			}
			title={t('DETAILS_COMPANIES_ATOKA_SECTION')}
			subheader={
				<>
					{/* <SquareChip label={props.atokaId} /> */}
					{props.lastImportDate && (
						<SquareChip
							label={intl.formatMessage(
								{
									id: 'companiesAtoka.lastUpdateDate',
									defaultMessage: t('COMPANIES_ATOKA_LAST_UPDATE')
								},
								{
									date: intl.formatDate(Utils.parseDate(props.lastImportDate)?.toDate(), {
										year: 'numeric',
										month: '2-digit',
										day: '2-digit',
										hour: '2-digit',
										minute: '2-digit'
									})
								}
							)}
						/>
					)}
				</>
			}
			headerAction={
				<Tooltip title={t('COMPANIES_ATOKA_BUTTON_RELINK')} arrow>
					<IconButton onClick={props.linkAtokaCompany}>
						<Icon icon="link-variant" />
					</IconButton>
				</Tooltip>
			}
		>
			<Typography>{t('DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_LINKED')}</Typography>
			<Typography variant="subtitle2">{t('DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_WARNING')}</Typography>
		</DetailsSectionWrapper>
	);
}
